// modules/caps.ts
export type HorizonCaps = Record<string, boolean>

let _caps: HorizonCaps = {}

// tiny pubsub so UI can react to caps updates
type CapsListener = (caps: HorizonCaps) => void
const _listeners = new Set<CapsListener>()

/**
 * Authoritative caps snapshot (eventually from session / server).
 * Non-reactive by design: modules sync when app/session changes.
 *
 * (But UI still needs a "caps changed" signal, so we add subscribeCaps.)
 */
export function setCaps(next: HorizonCaps) {
  _caps = next ?? {}
  for (const fn of _listeners) {
    try {
      fn(_caps)
    } catch {
      // swallow; fail closed elsewhere
    }
  }
}

export function getCaps(): HorizonCaps {
  return _caps
}

/**
 * What modules should see.
 * (For now identical to getCaps; later you can merge server/session claims here.)
 */
export function getEffectiveCaps(): HorizonCaps {
  return _caps
}

export function subscribeCaps(fn: CapsListener): () => void {
  _listeners.add(fn)
  return () => {
    _listeners.delete(fn)
  }
}
